const FeedbackPages = {
  data: [
    {
      id: 1,
      attributes: {
        createdAt: '2022-10-18T12:02:23.052Z',
        updatedAt: '2023-02-15T19:06:21.800Z',
        publishedAt: '2022-10-18T12:11:26.411Z',
        Title: 'Feedback &  Support',
        Slug: 'feedback-and-support',
        Data_Collection: `<p>
    &nbsp;
</p>
<p>
    <span style="font-size:17px;">If you have any issues with accessing the correct modules or questions around data submission, please submit a support ticket using the link below:&nbsp;</span>
    <br>
    <a target="_blank" rel="noopener noreferrer" href="https://go.ymca.net/formstack/datacollhub_support"><span style="color:#00AEEF;font-size:19px;"><strong><u>Submit Support Ticket</u></strong></span></a>
</p>
<p>
    &nbsp;
</p>
<p>
    <span style="color:hsl(0,0%,30%);"><strong>Annual Report&nbsp;</strong></span>
</p>
<p>
    &nbsp;<span style="font-family:Verdana, Geneva, sans-serif;"><img src="https://datacollectionhub-cms.y.org/uploads/ymca_list_icon_e32ccb96db.svg" alt="ymca-list-icon.svg"> &nbsp;</span><a target="_blank" rel="noopener noreferrer" href="https://link.ymca.net/mlink/file/NDg1OTEx"><span style="color:#00AEEF;font-family:Verdana, Geneva, sans-serif;"><u>Annual Report</u></span><span style="color:#00AEEF;"><u> Guide</u></span></a>
</p>
<p>
    &nbsp;<span style="font-family:Verdana, Geneva, sans-serif;"><img src="https://datacollectionhub-cms.y.org/uploads/ymca_list_icon_e32ccb96db.svg" alt="ymca-list-icon.svg"> &nbsp;</span><a target="_blank" rel="noopener noreferrer" href="https://link.ymca.net/mlink/file/NDkyMjQz?type=attachment"><span style="color:#00AEEF;font-family:Verdana, Geneva, sans-serif;"><u>Annual Report</u></span><span style="color:#00AEEF;"><u> Data Collection Template</u></span></a>
</p>
<p>
    &nbsp;<span style="font-family:Verdana, Geneva, sans-serif;"><img src="https://datacollectionhub-cms.y.org/uploads/ymca_list_icon_e32ccb96db.svg" alt="ymca-list-icon.svg"> &nbsp;</span><a target="_blank" rel="noopener noreferrer" href="https://experience.arcgis.com/experience/cee808c0392b4d068ed30c35f823361c"><span style="color:#00AEEF;"><u>Insights Hub</u></span></a>
</p>
<p>
    &nbsp;<span style="font-family:Verdana, Geneva, sans-serif;"><img src="https://datacollectionhub-cms.y.org/uploads/ymca_list_icon_e32ccb96db.svg" alt="ymca-list-icon.svg"> &nbsp;</span><a target="_blank" rel="noopener noreferrer" href="https://ctrac.k1x.io"><span style="color:#00AEEF;"><u>CTRAC</u></span></a>
</p>
<p>
    <span style="color:hsl(0,0%,30%);"><strong>Employee Update</strong></span>
</p>
<p>
    &nbsp;<span style="font-family:Verdana, Geneva, sans-serif;"><img src="https://datacollectionhub-cms.y.org/uploads/ymca_list_icon_e32ccb96db.svg" alt="ymca-list-icon.svg"> &nbsp;</span><a target="_blank" rel="noopener noreferrer" href="https://link.ymca.net/user/document/485911"><span style="color:#00AEEF;font-family:Verdana, Geneva, sans-serif;"><u>Employee Update</u></span><span style="color:#00AEEF;"><u> Guide</u></span></a><span style="color:#00AEEF;"><u> (see Appendix)</u></span>
</p>
<p>
    &nbsp;<strong>Chronic Disease Program</strong>
</p>
<p>
    &nbsp;<span style="font-family:Verdana, Geneva, sans-serif;"><img src="https://datacollectionhub-cms.y.org/uploads/ymca_list_icon_e32ccb96db.svg" alt="ymca-list-icon.svg"> &nbsp;</span><a target="_blank" rel="noopener noreferrer" href="https://link.ymca.net/mlink/file/ODEzMDU0?type=attachment"><span style="color:#00AEEF;font-family:Verdana, Geneva, sans-serif;"><u>Chronic Disease Program Guide</u></span></a>
</p>
<p>
    <strong>Certificate of Liability Insurance</strong>
</p>
<p>
    <span style="font-family:Verdana, Geneva, sans-serif;"><img src="https://datacollectionhub-cms.y.org/uploads/ymca_list_icon_e32ccb96db.svg" alt="ymca-list-icon.svg"></span> <a target="_blank" rel="noopener noreferrer" href="https://link.ymca.net/mlink/file/NzU5MjYz?type=attachment"><span style="font-family:Verdana, Geneva, sans-serif;">Certificate of Liability Insurance Guide</span></a>
</p>
<p>
    <strong>Volunteer Registration</strong>
</p>
<p>
    <span style="background-color:rgb(255,255,255);color:rgb(102,102,102);font-family:-apple-system, blinkmacsystemfont, &quot;Segoe UI&quot;, roboto, &quot;Helvetica Neue&quot;, arial, sans-serif, &quot;Apple Color Emoji&quot;, &quot;Segoe UI Emoji&quot;, &quot;Segoe UI Symbol&quot;, &quot;Noto Color Emoji&quot;;">Please contact Meredith Griffin at </span><a href="mailto:Meredith.Griffin@ymca.net">Meredith.Griffin@ymca.net</a> for Volunteer Registration module questions.
</p>
<p>
    <strong>Other Helpful Resources</strong>
</p>
<p>
    <span style="font-family:Verdana, Geneva, sans-serif;"><img src="https://datacollectionhub-cms.y.org/uploads/ymca_list_icon_e32ccb96db.svg" alt="ymca-list-icon.svg"></span><a target="_blank" rel="noopener noreferrer" href="https://moyp.yexchange.org/"> &nbsp;Manage Our Y Profile (MOYP)</a>
</p>
<p>
    <span style="font-family:Verdana, Geneva, sans-serif;"><img src="https://datacollectionhub-cms.y.org/uploads/ymca_list_icon_e32ccb96db.svg" alt="ymca-list-icon.svg"></span>&nbsp;<a target="_blank" rel="noopener noreferrer" href="https://media.ymca.net/moyp/local-y-how-to-guide.pdf"> Manage Our Y Profile How-To Guide</a>
</p>
<p>
    &nbsp;
</p>
<p>
    &nbsp;
</p>`
      }
    }
  ],
  meta: {
    pagination: { page: 1, pageSize: 25, pageCount: 1, total: 1 }
  }
};

export default FeedbackPages;
